import(/* webpackMode: "eager", webpackExports: ["FeaturesIndexView"] */ "/vercel/path0/apps/web/src/sections/features/index/view/features-view.tsx");
